export function checkIsNegative(value: number) {
  return value < 0
}
